import { Icon, type IconType } from '@graftcode/design-system'

/** Stack / language ids → design-system technology icons (shared by onboarding and academy). */
export const TECHNOLOGY_STACK_ICON_MAP: Record<string, IconType> = {
  angular: Icon.DSAngularColor,
  astro: Icon.DSAstroColor,
  clojure: Icon.DSClojureColor,
  cpp: Icon.DSCppColor,
  'c++': Icon.DSCppColor,
  cplusplus: Icon.DSCppColor,
  csharp: Icon.DSCSharpColor,
  cs: Icon.DSCSharpColor,
  dotnet: Icon.DSCSharpColor,
  fsharp: Icon.DSCSharpColor,
  fs: Icon.DSCSharpColor,
  golang: Icon.DSGoColor,
  go: Icon.DSGoColor,
  groovy: Icon.DSGroovyColor,
  java: Icon.DSJavaColor,
  javascript: Icon.DSJsColor,
  js: Icon.DSJsColor,
  kotlin: Icon.DSKotlinColor,
  nextjs: Icon.DSNextjsColor,
  perl: Icon.DSPerlColor,
  php: Icon.DSPhpColor,
  preact: Icon.DSPreactColor,
  python: Icon.DSPythonColor,
  py: Icon.DSPythonColor,
  qwik: Icon.DSQwikColor,
  rb: Icon.DSRubyColor,
  react: Icon.DSReactColor,
  ruby: Icon.DSRubyColor,
  solidjs: Icon.DSSolidjsColor,
  svelte: Icon.DSSvelteColor,
  ts: Icon.DSTsColor,
  typescript: Icon.DSTsColor,
  vanillajs: Icon.DSVanillaJsColor,
  vue: Icon.DSVueColor,
  webassembly: Icon.DSWebAssemblyColor,
}

export function getTechnologyStackIcon(stackId: string): IconType | undefined {
  return TECHNOLOGY_STACK_ICON_MAP[stackId.toLowerCase()]
}
